import * as Cookies from 'es-cookie';
import ISimpleEvent from '../events/ISimpleEvent';
import SimpleEvent from '../events/SimpleEvent';

export default class AuthHelper {
  private static readonly AuthCookieName: string = 'VotingAppAuth';
  private static readonly EmailCookieName: string = 'VotingAppEmail';
  private static readonly onChangeEventDispatcher = new SimpleEvent<void>();

  public static setAccessToken(token: string, expirationSeconds: Date): void {
    Cookies.set(AuthHelper.AuthCookieName, token, {expires: expirationSeconds});

    this.onChangeEventDispatcher.trigger();
  }

  public static getAccessToken(): string | undefined {
    return Cookies.get(AuthHelper.AuthCookieName);
  }

  public static isTokenSet(): boolean {
    let token = AuthHelper.getAccessToken();

    return token !== undefined && token !== null && token !== '';
  }

  public static setEmail(email: string, expirationSeconds: Date): void {
    Cookies.set(AuthHelper.EmailCookieName, email, {expires: expirationSeconds});

    this.onChangeEventDispatcher.trigger();
  }

  public static getEmail(): string | undefined {
    return Cookies.get(AuthHelper.EmailCookieName);
  }

  public static removeSession() {
    Cookies.remove(this.AuthCookieName);

    let today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    AuthHelper.setAccessToken('', yesterday);
  }

  public static get onChange(): ISimpleEvent<void> {
    return this.onChangeEventDispatcher;
  }
}